import React from "react";
import BaseButton from "@components/library/UI/BaseButton";
import ArrowIcon from '@components/library/Icons/ArrowIcon';
import "./FormButton.sass";

const FormButton = ({
  children,
  variant = "primary",
  disabled = false,
  className = "",
  ...props
}) => {
  const variantClass = disabled
    ? "form-button--disabled"
    : `form-button--${variant}`;
  const classes = `form-button ${variantClass} ${className}`.trim();

  return (
    <BaseButton className={classes} disabled={disabled} {...props}>
      <span className="whitespace-nowrap">{children}</span>
      <ArrowIcon className="form-button__icon" />
    </BaseButton>
  );
};

export default FormButton;
